import React, { useEffect } from "react";
import {
  Route,
  Routes,
  Navigate,
  useLocation,
  useNavigate,
} from "react-router-dom";
import Home from "../Components/Home/Home";
import Login from "../Components/Account/Login/Login";
import Users from "../Components/Users/Users";
import ForgotPassword from "../Components/Account/ForgotPassword/ForgotPassword";
import AddOrEditUser from "../Components/Users/AddOrEditUser/AddOrEditUser";
import PermissionsUser from "../Components/Users/PermissionsUser/PermissionsUser";
import Clients from "../Components/Clients/Clients";
import AddOrEditClient from "../Components/Clients/AddOrEditClient";
import Contact from "../Components/Contact/Contact";
import AddOrEditContact from "../Components/Contact/AddOrEditContact";
import Employees from "../Components/Employees/Employees";
import AddOrEditEmployee from "../Components/Employees/AddOrEditEmployee";
import Locations from "../Components/Locations/Locations";
import AddOrEditLocations from "../Components/Locations/AddOrEditLocations";
import Madrinas from "../Components/Madrinas/Madrinas";
import AddOrEditMadrina from "../Components/Madrinas/AddOrEditMadrina";
import Loads from "../Components/Loads/Loads";
import ImportLoads from "../Components/Loads/ImportLoad";
import DetailsLoads from "../Components/Loads/DetailsLoads";
import AddOrEditLoads from "../Components/Loads/AddOrEditLoads";
import CheckList from "../Components/CheckList/CheckList";
import AddOrEditChecklist from "../Components/CheckList/AddOrEditCheckList";
import Inspections from "../Components/Inspections/Inspections";
import Units from "../Components/Units/Units";
import AddOrEditUnits from "../Components/Units/AddOrEditUnits";
import ModelUnit from "../Components/ModelUnit/ModelUnit";
import AddOrEditModelUnit from "../Components/ModelUnit/AddOrEditModelUnit";
import ImportUnits from "../Components/Units/ImportUnits";
import InspectionPoint from "../Components/InspectionPoint/InspectionPoint";
import AddOrEditInspectionPoint from "../Components/InspectionPoint/AddOrEditInspectionPoint";
import DetailsInspections from "../Components/Inspections/DetailsInspections";
import ReportsInspections from "../Components/Reports/ReportsInspections/ReportsInspections";
import ReportDamageForInspector from "../Components/Reports/ReportsInspections/ReportDamageForInspector";
import ReportDamageForArea from "../Components/Reports/ReportsInspections/ReportDamageForArea";
import AvisoPrivacidad from '../Components/Account/AvisoPrivacidad/AvisoPrivacidad';

const RoutesConfig = ({
  user,
  handleLogin,
  permissions,
  config,
  isAuthenticated,
}) => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated && location.pathname !== "/Account/Login") {
      localStorage.setItem("lastVisitedUrl", location.pathname);
    }
  }, [isAuthenticated, location.pathname, navigate]);

  useEffect(() => {
    const lastVisitedUrl = localStorage.getItem("lastVisitedUrl");
    if (isAuthenticated && lastVisitedUrl) {
      navigate(lastVisitedUrl);
    }
  }, [isAuthenticated, navigate]);

  return (
    <Routes>
      <Route
        path="/Account/Login"
        element={
          user ? (
            <Navigate to="/" replace />
          ) : (
            <Login onLogin={handleLogin} config={config} />
          )
        }
      />

      <Route
        path="/Account/ForgotPassword"
        element={<ForgotPassword config={config} />}
      />
        <Route
        path="/Account/AvisoPrivacidad"
        element={<AvisoPrivacidad config={config} />}
      />

      <Route
        path="/"
        element={
          isAuthenticated ? (
            <Home className="content-section" />
          ) : (
            <Navigate to="/Account/Login" replace />
          )
        }
      />

      {/* Usuarios */}
      <Route
        path="/Usuarios"
        element={
          isAuthenticated ? (
            <Users config={config} />
          ) : (
            <Navigate to="/Account/Login" />
          )
        }
      />
      <Route
        path="/Usuarios/Agregar"
        element={
          isAuthenticated ? (
            <AddOrEditUser config={config} />
          ) : (
            <Navigate to="/Account/Login" />
          )
        }
      />
      <Route
        path="/Usuarios/Editar/:id"
        element={
          isAuthenticated ? (
            <AddOrEditUser config={config} />
          ) : (
            <Navigate to="/Account/Login" />
          )
        }
      />
      <Route
        path="/Usuarios/PermisosUsuarios/:id"
        element={
          isAuthenticated ? (
            <PermissionsUser config={config} />
          ) : (
            <Navigate to="/Account/Login" />
          )
        }
      />
      {/* Clientes */}
      <Route
        path="/Clientes"
        element={
          isAuthenticated ? (
            <Clients config={config} />
          ) : (
            <Navigate to="/Account/Login" />
          )
        }
      />
      <Route
        path="/Clientes/Agregar"
        element={
          isAuthenticated ? (
            <AddOrEditClient config={config} />
          ) : (
            <Navigate to="/Account/Login" />
          )
        }
      />
      <Route
        path="/Clientes/Editar/:id"
        element={
          isAuthenticated ? (
            <AddOrEditClient config={config} />
          ) : (
            <Navigate to="/Account/Login" />
          )
        }
      />
           {/* Contactos */}
           <Route
        path="/Contactos"
        element={
          isAuthenticated ? (
            <Contact config={config} />
          ) : (
            <Navigate to="/Account/Login" />
          )
        }
      />
      <Route
        path="/Contactos/Agregar"
        element={
          isAuthenticated ? (
            <AddOrEditContact config={config} />
          ) : (
            <Navigate to="/Account/Login" />
          )
        }
      />
      <Route
        path="/Contactos/Editar/:id"
        element={
          isAuthenticated ? (
            <AddOrEditContact config={config} />
          ) : (
            <Navigate to="/Account/Login" />
          )
        }
      />
      {/* Empleados */}
      <Route
        path="/Empleados"
        element={
          isAuthenticated ? (
            <Employees config={config} />
          ) : (
            <Navigate to="/Account/Login" />
          )
        }
      />
      <Route
        path="/Empleados/Agregar"
        element={
          isAuthenticated ? (
            <AddOrEditEmployee config={config} />
          ) : (
            <Navigate to="/Account/Login" />
          )
        }
      />
      <Route
        path="/Empleados/Editar/:id"
        element={
          isAuthenticated ? (
            <AddOrEditEmployee config={config} />
          ) : (
            <Navigate to="/Account/Login" />
          )
        }
      />
      {/* Ubicaciones */}
      <Route
        path="/Ubicaciones"
        element={
          isAuthenticated ? (
            <Locations config={config} />
          ) : (
            <Navigate to="/Account/Login" />
          )
        }
      />
      <Route
        path="/Ubicaciones/Agregar"
        element={
          isAuthenticated ? (
            <AddOrEditLocations config={config} />
          ) : (
            <Navigate to="/Account/Login" />
          )
        }
      />
      <Route
        path="/Ubicaciones/Editar/:id"
        element={
          isAuthenticated ? (
            <AddOrEditLocations config={config} />
          ) : (
            <Navigate to="/Account/Login" />
          )
        }
      />
      {/* Madrinas */}
      <Route
        path="/Madrinas"
        element={
          isAuthenticated ? (
            <Madrinas config={config} />
          ) : (
            <Navigate to="/Account/Login" />
          )
        }
      />
      <Route
        path="/Madrinas/Agregar"
        element={
          isAuthenticated ? (
            <AddOrEditMadrina config={config} />
          ) : (
            <Navigate to="/Account/Login" />
          )
        }
      />
      <Route
        path="/Madrinas/Editar/:id"
        element={
          isAuthenticated ? (
            <AddOrEditMadrina config={config} />
          ) : (
            <Navigate to="/Account/Login" />
          )
        }
      />
      {/* Cargas */}
      <Route
        path="/Cargas"
        element={
          isAuthenticated ? (
            <Loads config={config} />
          ) : (
            <Navigate to="/Account/Login" />
          )
        }
      />
      <Route
        path="/Cargas/ImportarCargas"
        element={
          isAuthenticated ? (
            <ImportLoads config={config} />
          ) : (
            <Navigate to="/Account/Login" />
          )
        }
      />
      <Route
        path="/Cargas/Detalle/:id"
        element={
          isAuthenticated ? (
            <DetailsLoads config={config} />
          ) : (
            <Navigate to="/Account/Login" />
          )
        }
      />
      <Route
        path="/Cargas/Agregar"
        element={
          isAuthenticated ? (
            <AddOrEditLoads config={config} />
          ) : (
            <Navigate to="/Account/Login" />
          )
        }
      />
      <Route
        path="/Cargas/Editar/:id"
        element={
          isAuthenticated ? (
            <AddOrEditLoads config={config} />
          ) : (
            <Navigate to="/Account/Login" />
          )
        }
      />
      {/*CheckList*/}
      <Route
        path="/CheckList"
        element={
          isAuthenticated ? (
            <CheckList config={config} />
          ) : (
            <Navigate to="/Account/Login" />
          )
        }
      />
      <Route
        path="/Checklist/Agregar"
        element={
          isAuthenticated ? (
            <AddOrEditChecklist config={config} />
          ) : (
            <Navigate to="/Account/Login" />
          )
        }
      />
      <Route
        path="/Checklist/Editar/:id"
        element={
          isAuthenticated ? (
            <AddOrEditChecklist config={config} />
          ) : (
            <Navigate to="/Account/Login" />
          )
        }
      />
      {/*Inspecciones*/}
      <Route
        path="/Inspecciones"
        element={
          isAuthenticated ? (
            <Inspections config={config} />
          ) : (
            <Navigate to="/Account/Login" />
          )
        }
      />
      <Route
        path="/Inspecciones/Detalle/:id"
        element={
          isAuthenticated ? (
            <DetailsInspections config={config} />
          ) : (
            <Navigate to="/Account/Login" />
          )
        }
      />
      {/*Unidades*/}
      <Route
        path="/Unidades"
        element={
          isAuthenticated ? (
            <Units config={config} />
          ) : (
            <Navigate to="/Account/Login" />
          )
        }
      />
      <Route
        path="/Unidades/Agregar"
        element={
          isAuthenticated ? (
            <AddOrEditUnits config={config} />
          ) : (
            <Navigate to="/Account/Login" />
          )
        }
      />
      <Route
        path="/Unidades/Editar/:id"
        element={
          isAuthenticated ? (
            <AddOrEditUnits config={config} />
          ) : (
            <Navigate to="/Account/Login" />
          )
        }
      />
      <Route
        path="/Unidades/ImportarUnidades"
        element={
          isAuthenticated ? (
            <ImportUnits config={config} />
          ) : (
            <Navigate to="/Account/Login" />
          )
        }
      />
      {/*Modelos de Unidad */}
      <Route
        path="/ModelosUnidad"
        element={
          isAuthenticated ? (
            <ModelUnit config={config} />
          ) : (
            <Navigate to="/Account/Login" />
          )
        }
      />
      <Route
        path="/ModelosUnidad/Agregar"
        element={
          isAuthenticated ? (
            <AddOrEditModelUnit config={config} />
          ) : (
            <Navigate to="/Account/Login" />
          )
        }
      />
      <Route
        path="/ModelosUnidad/Editar/:id"
        element={
          isAuthenticated ? (
            <AddOrEditModelUnit config={config} />
          ) : (
            <Navigate to="/Account/Login" />
          )
        }
      />
      {/*InpectionPoint*/}
      <Route
        path="/PuntosInspeccion"
        element={
          isAuthenticated ? (
            <InspectionPoint config={config} />
          ) : (
            <Navigate to="/Account/Login" />
          )
        }
      />
      <Route
        path="/PuntosInspeccion/Editar/:id"
        element={
          isAuthenticated ? (
            <AddOrEditInspectionPoint config={config} />
          ) : (
            <Navigate to="/Account/Login" />
          )
        }
      />
      <Route
        path="/PuntosInspeccion/Agregar"
        element={
          isAuthenticated ? (
            <AddOrEditInspectionPoint config={config} />
          ) : (
            <Navigate to="/Account/Login" />
          )
        }
      />
      {/*Reportes*/}
      <Route
        path="/ReportesInspeccion"
        element={
          isAuthenticated ? (
            <ReportsInspections config={config} />
          ) : (
            <Navigate to="/Account/Login" />
          )
        }
      />
      {/*Reportes de Inspeccion */}
      <Route
        path="/ReportesInspeccion/ReporteDeDañosPorInspector"
        element={
          isAuthenticated ? (
            <ReportDamageForInspector config={config} />
          ) : (
            <Navigate to="/Account/Login" />
          )
        }
      />
      <Route
        path="/ReportesInspeccion/ReporteDeDañosPorArea"
        element={
          isAuthenticated ? (
            <ReportDamageForArea config={config} />
          ) : (
            <Navigate to="/Account/Login" />
          )
        }
      />
    </Routes>
  );
};

export default RoutesConfig;
